module.exports = __webpack_public_path__ + "static/media/download_button.729e47ba.svg";